export default "__VITE_ASSET__BLcUtXY$__"